// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__jid0L","gradient":"Banner_gradient__7C9KH","info":"Banner_info__J18Bg","content":"Banner_content__EKH5J","closeButton":"Banner_closeButton__DCVhS"};